/** Inline SVG icons of the KPI portal: 20×20 viewBox, 1.5px stroke, square caps (UIUX handoff README). */
const ICON_PATHS = {
  overview: 'M3 3h6v6H3zM11 3h6v6h-6zM3 11h6v6H3zM11 11h6v6h-6z',
  revenue: 'M3 17h14M5 14v-4M8.5 14V6M12 14V9M15.5 14V4',
  trend: 'M3 14l4.5-4.5 3 3L17 6M12.5 6H17v4.5',
  subscriptions: 'M3 5h14M3 10h14M3 15h14',
  calendar: 'M3 5h14v12H3zM3 8h14M7 3v4M13 3v4',
  offers: 'M3 3h7l7 7-7 7-7-7zM6.5 6.5h1v1h-1z',
  users:
    'M7.5 9a3 3 0 100-6 3 3 0 000 6zM2 17a5.5 5.5 0 0111 0M13 3.5a3 3 0 010 5.5M15 12a4.5 4.5 0 013 5',
  apps: 'M6 2h8v16H6zM9 15h2',
  cohorts: 'M3 3h14v14H3zM3 8h14M3 13h14M8 3v14M13 3v14',
  chevron: 'M5 8l5 5 5-5',
  up: 'M5 12l5-5 5 5',
  left: 'M12 5l-5 5 5 5',
  right: 'M8 5l5 5-5 5',
  close: 'M4 4l12 12M16 4L4 16',
  plus: 'M10 4v12M4 10h12',
  search: 'M8.5 15a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM13.5 13.5L18 18',
  customize: 'M3 5h8M15 5h2M3 10h2M9 10h8M3 15h10M17 15h0M11 3v4M5 8v4M13 13v4',
  lock: 'M5 9h10v8H5zM7 9V6a3 3 0 016 0v3',
  mail: 'M3 5h14v10H3zM3 5l7 6 7-6',
  alert: 'M10 3l8 14H2zM10 8v4M10 14v1',
  signOut: 'M8 4H4v12h4M12 6l4 4-4 4M16 10H8',
  help: 'M10 18a8 8 0 100-16 8 8 0 000 16zM7.75 7.75a2.25 2.25 0 114.1 1.3c-.6.8-1.85 1.2-1.85 2.45v.5M10 14v1',
  bulb: 'M10 2.5a5 5 0 00-3 9c.6.45 1 1.15 1 1.9V14h4v-.6c0-.75.4-1.45 1-1.9a5 5 0 00-3-9zM8 16.5h4',
  graph: 'M3 3h4v4H3zM13 3h4v4h-4zM13 13h4v4h-4zM7 5h6M15 7v6M6.5 6.5l7 7',
  funnel: 'M3 4h14l-5.5 6.5V16l-3 1.5v-7z',
  globe:
    'M10 18a8 8 0 100-16 8 8 0 000 16zM2 10h16M10 2c2.5 2.6 2.5 13.4 0 16M10 2c-2.5 2.6-2.5 13.4 0 16',
  target: 'M10 18a8 8 0 100-16 8 8 0 000 16zM10 14a4 4 0 100-8 4 4 0 000 8zM10 10h0',
  database:
    'M3.5 4.5a6.5 2.5 0 1013 0 6.5 2.5 0 10-13 0zM3.5 4.5v11a6.5 2.5 0 0013 0v-11M3.5 10a6.5 2.5 0 0013 0',
  download: 'M10 3v10M6 9l4 4 4-4M4 17h12',
  sparkle:
    'M8.5 3l1.6 4.9 4.9 1.6-4.9 1.6-1.6 4.9-1.6-4.9-4.9-1.6 4.9-1.6zM15.5 2.5l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6z',
} as const;

export type IconName = keyof typeof ICON_PATHS;

interface IconProps {
  name: IconName;
  size?: 'sm' | 'xs';
}

export function Icon({ name, size }: IconProps) {
  return (
    <svg className={size ? `icon icon--${size}` : 'icon'} viewBox="0 0 20 20" aria-hidden="true">
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}

/** Microsoft logo (four squares) per Microsoft's sign-in button guidelines. */
export function MsLogo() {
  return (
    <svg className="ms-logo" viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}
